import {useEffect, useRef} from 'react';

import {billingStore} from '../../../agentChat/billing';
import {useWBAgentWindowStore} from '../../WBAgent/window/useWBAgentWindowStore';

/**
 * useRefreshBillingOnOpen refreshes billing when the chat panel opens, catching
 * quota spent while it was closed (e.g. by org peers).
 */
export function useRefreshBillingOnOpen(): void {
  const open = useWBAgentWindowStore(state => state.open);
  const wasOpen = useRef(open);
  useEffect(() => {
    if (open && !wasOpen.current) {
      billingStore.refresh();
    }

    wasOpen.current = open;
  }, [open]);
}
